import { FormattedMessage } from 'react-intl';

import IconRight from '@/assets/icons/icon-right.svg';
import { Button } from '@/components/ui/button';
import { useOpeningContext, useOpeningDetails } from '@/contexts/opening-context';

import { BANNER_ACTION_BUTTON_CLASSNAME } from './create-hiring-goal-button';
import { LIFETIME } from '@/components/ui/date-range-picker';
import { useMetricsFilterParams } from '@/hooks/use-metrics-filter-params';

export function ViewSourcingToggleButton() {
  const { metricsViewMode, setMetricsViewMode } = useOpeningContext();
  const {
    recentPastHiringGoal,
    opening: { defaultMetricsPeriod, hasActiveHiringGoal },
  } = useOpeningDetails();
  const { clearMetricsFilter } = useMetricsFilterParams();

  if (!recentPastHiringGoal && metricsViewMode === 'date_range') return null;
  if (hasActiveHiringGoal && metricsViewMode === 'date_range') return null;

  const handleClick = () => {
    if (metricsViewMode === 'hiring_goal') {
      // If there is an active hiring goal, and the user is viewing the hiring goal tab, clear all filter
      // so that user sees the current hiring goal info
      // else, switch to the date range tab with the default metrics period
      if (hasActiveHiringGoal) {
        clearMetricsFilter();
      } else {
        setMetricsViewMode('date_range', defaultMetricsPeriod ?? LIFETIME);
      }
    } else {
      setMetricsViewMode('hiring_goal');
    }
  };

  const label =
    metricsViewMode === 'date_range' ? (
      <FormattedMessage
        defaultMessage="View past performance"
        description="Banner CTA: switch overview metrics to the hiring goal tab"
      />
    ) : (
      <FormattedMessage
        defaultMessage="View current sourcing"
        description="Banner CTA: switch overview metrics to the date range tab"
      />
    );


  return (
    <Button
      className={BANNER_ACTION_BUTTON_CLASSNAME}
      variant="secondary"
      onClick={handleClick}
    >
      {label}
      <img src={IconRight} alt="" aria-hidden="true" />
    </Button>
  );
}
